import { Autocomplete, Box } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import AppButton from 'src/components/appComponents/AppButton';
import Iconify from 'src/components/iconify';
import { RouterLink } from 'src/routes/components';
import { paths } from 'src/routes/paths';
import { IMarketingSearch } from 'src/types/marketing';
import { handleDebouncedSearch } from 'src/utils/helper';

type Props = {
  search?: IMarketingSearch;
  setSearch: React.Dispatch<React.SetStateAction<any>>;
};

export default function MarketingTableToolbar({ search, setSearch }: Props) {
  return (
    <>
      <Stack
        spacing={2}
        alignItems={{ xs: 'flex-end', md: 'center' }}
        direction={{
          xs: 'column',
          md: 'row',
        }}
      >
        <TextField
          size="small"
          placeholder="Search Keyword"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Iconify icon="eva:search-fill" sx={{ color: '#c6ddb4' }} />
              </InputAdornment>
            ),
          }}
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            handleDebouncedSearch(() => setSearch({ ...search, keywords: event.target.value }));
          }}
        />
        <Autocomplete
          defaultValue={{ label: 'Android', value: 'GOOGLE' }}
          onChange={(event, newValue) => {
            setSearch({ ...search, type: newValue?.value });
          }}
          renderInput={(params) => <TextField label="Fillter Phone Type" {...params} />}
          size="small"
          sx={{ width: 300 }}
          autoHighlight
          options={[
            { label: 'Android', value: 'GOOGLE', icon: 'jam:android' },
            { label: 'iPhone', value: 'APPLE', icon: 'uim:apple' },
          ]}
          getOptionLabel={(option: any) => option.label}
          renderOption={(props, option) => (
            <li {...props} key={option?.value}>
              <Iconify icon={option.icon!} />
              {option.label}
            </li>
          )}
        />

        <Box sx={{ ml: 'auto' }}>
          <AppButton
            label="Add Marketing"
            buttonIcon={<Iconify icon="material-symbols:add" />}
            linkCompoennt={RouterLink}
            href={paths.dashboard.marketing.addMarketing}
          />
        </Box>
      </Stack>
    </>
  );
}
